module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_encuentra_doctor.c8365dc0.jpg";